var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class KanexPro {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`/^Version;`, /^V(.+)/i, tags);
                return match[1];
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`Status.`, /^Power\s*(ON|OFF)/i, tags);
                return match[1].toUpperCase() === 'ON';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW${power ? 'ON' : 'OFF'}.`, /^PW\s*(ON|OFF)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 5000 : 1000);
                this.framework.suspend(power ? 5000 : 1000);
                return match[1].toUpperCase() === 'ON';
            }),
            asyncHandlers: {
                regExp: /^Power\s*(ON|OFF)/i,
                callback: (match) => {
                    this.state.power.update(match[1].toUpperCase() === 'ON');
                },
            },
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`Status${key}.`, /V:\s*(\d+)->(\d+)/i, tags);
                return parseInt(match[1], 10).toString(); // remove leading zeros
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${value.padStart(2, '0')}B${key.padStart(3, '0')}.`, /AV:\s*(\d+)->(\d+)/i, tags);
                return parseInt(match[1], 10).toString(); // remove leading zeros
            }),
            asyncHandlers: {
                regExp: /V:\s*(\d+)->(\d+)/i,
                callback: (match) => {
                    const key = parseInt(match[2], 10).toString();
                    const value = parseInt(match[1], 10).toString();
                    this.state.videoMatrixRoutes.update(key, value);
                },
            },
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 5000, controls: ['power', 'videoMatrixRoutes'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    send: '/^Version;',
                    next: /V\s*[\d\.]+|CMD Error|Please Input Your Command/i,
                },
            ], credentials);
        });
    }
}
// static properties
KanexPro.driverType = 'socketDriver';
KanexPro.key = '-Ng428QSpsqPT1VTEHV1';
KanexPro.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
KanexPro.socketOptions = [
    Object.assign(Object.assign({}, KanexPro.baseSocketOptions), { port: 4001 }),
    Object.assign(Object.assign({}, KanexPro.baseSocketOptions), { port: 4999 }),
];
